/* Instalace webu na plochu telefonu.
 *
 * Android/Chrome umí nativní prompt (beforeinstallprompt), iOS ne — tam se
 * musí přes Sdílet → Přidat na plochu, takže Applu ukazujeme návod. Bez
 * instalace na iOS navíc nepůjdou notifikace, které chystáme v další etapě.
 */

const KLIC_SKRYTO = "sdh-instalace-skryta";

function jeNainstalovano() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

function jeIos() {
  return (
    /iphone|ipad|ipod/i.test(navigator.userAgent) ||
    // iPad se od iPadOS 13 hlásí jako Mac, poznáme ho podle dotyku
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

function bylOdmitnut() {
  try {
    return localStorage.getItem(KLIC_SKRYTO) === "1";
  } catch {
    return false; // soukromé okno — stav si nezapamatujeme, nabídku ukážeme
  }
}

function zapamatujOdmitnuti() {
  try {
    localStorage.setItem(KLIC_SKRYTO, "1");
  } catch {
    /* soukromé okno, nevadí */
  }
}

function postavListu({ text, tlacitko, onKlik }) {
  const el = document.createElement("div");
  el.className = "install-bar";
  el.innerHTML =
    '<span class="install-bar__text"></span>' +
    '<div class="install-bar__actions">' +
    (tlacitko ? '<button type="button" class="install-bar__go"></button>' : "") +
    '<button type="button" class="install-bar__close" aria-label="Skrýt nabídku">×</button>' +
    "</div>";
  el.querySelector(".install-bar__text").textContent = text;
  const go = el.querySelector(".install-bar__go");
  if (go) {
    go.textContent = tlacitko;
    go.addEventListener("click", onKlik);
  }
  el.querySelector(".install-bar__close").addEventListener("click", () => {
    zapamatujOdmitnuti();
    el.remove();
  });
  document.body.appendChild(el);
  requestAnimationFrame(() => el.classList.add("install-bar--in"));
  return el;
}

export function initPwa() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {
        /* bez service workeru web funguje dál, jen nepůjde offline */
      });
    });
  }

  if (jeNainstalovano() || bylOdmitnut()) return;

  // Android a spol. — počkáme, až prohlížeč sám nabídne instalaci.
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    const lista = postavListu({
      text: "Přidejte si výsledkovku na plochu telefonu.",
      tlacitko: "Přidat",
      onKlik: async () => {
        lista.remove();
        event.prompt();
        const { outcome } = await event.userChoice;
        if (outcome !== "accepted") zapamatujOdmitnuti();
      },
    });
  });

  // iOS prompt nemá, ukážeme návod — ale jen na telefonu, ne na desktopu.
  if (jeIos() && window.innerWidth < 992) {
    setTimeout(() => {
      if (bylOdmitnut()) return;
      postavListu({
        text: "Přidejte si nás na plochu, ať vám neuteče živá výsledkovka — klepněte na Sdílet a zvolte Přidat na plochu.",
      });
    }, 2500);
  }
}
